import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import useCustomFecthQuery from "../../../../Hooks/useCustomFecthQuery";
import useCustomMutation from "../../../../Hooks/useCustomMutation";
import ViewSpeaker from "./ViewSpeaker";
import EditSpeaker from "./EditSpeaker";
import ModalDelete from "../../../Modal/ModalDelete";
import DeleteForm from "./DeleteForm";
import OffCanvas from "../../../OffCanvas/OffCanvas";
import { FaEdit } from "react-icons/fa";
import { AiFillEye, AiFillDelete } from "react-icons/ai";

const TableSpeaker = ({ userID, token, eventID, search }) => {
  const [speakerID, setSpeakerID] = useState(false);
  const [speakerEmail, setSpeakerEmail] = useState(null);
  const [speakerDetails, setSpeakerDetails] = useState(null);
  const [isToggleView, setIsToggleView] = useState(false);
  const [isToggleEdit, setIsToggleEdit] = useState(false);
  const [isToggleDelete, setIsToggleDelete] = useState(false);
  const key = ["mySpeakers", eventID];

  const mutationDelete = useCustomMutation(key);

  const {
    data: getSpeakers,
    error: errorGetSpeakers,
    isLoading: isLoadingGetSpeakers,
  } = useCustomFecthQuery(
    key,
    `${process.env.REACT_APP_API}speakers/event/${eventID}`,
    token,
    {
      enabled: !!eventID,
    }
  );

  const tog_viewParticipant = (details) => {
    setSpeakerDetails(details);
    setIsToggleView(!isToggleView);
  };
  const tog_editParticipant = (details) => {
    setSpeakerDetails(details);
    setIsToggleEdit(!isToggleEdit);
  };
  const tog_deleteParticipant = (id, email) => {
    setSpeakerID(id);
    setSpeakerEmail(email);
    setIsToggleDelete(!isToggleDelete);
  };

  const DeleteParticitant = () => {
    const Method = "DELETE",
      url = `speakers/${speakerID}`,
      isJSON = null;
    var raw = null;
    const data = {
      endPoint: url,
      bodyContent: raw,
      Method: Method,
      displayMessage: "Speaker successfully deleted",
      token: token,
      isJSON: isJSON,
    };
    mutationDelete.mutate(data);
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">First Name</span>,
      selector: (row) => row?.firstName,
    },
    {
      name: <span className="font-weight-bold fs-13">Last Name</span>,
      selector: (row) => row?.lastName,
    },
    {
      name: <span className="font-weight-bold fs-13">JobTitle</span>,
      selector: (row) => row?.jobTitle,
    },
    {
      name: <span className="font-weight-bold fs-13">Email</span>,
      selector: (row) => row?.email,
    },

    {
      name: <span className="font-weight-bold fs-13">Action</span>,

      cell: (row) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <AiFillEye
                size={20}
                className="mx-1"
                onClick={() => tog_viewParticipant(row)}
              />
            </div>
            <div>
              <FaEdit
                size={18}
                className="mx-1"
                onClick={() => tog_editParticipant(row)}
              />
            </div>

            <div>
              <AiFillDelete
                size={20}
                onClick={() => tog_deleteParticipant(row?._id, row?.email)}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const filterParticipants = (participants, searchQuery) => {
    if (!searchQuery) return participants;
    return participants?.filter((item) =>
      [item?.firstName, item?.lastName, item?.email, item?.jobTitle].some(
        (field) => field?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  };
  const filteredSpeakers = filterParticipants(getSpeakers?.data, search);

  const data = filteredSpeakers;
  useEffect(() => {
    if (mutationDelete.isSuccess) {
      setIsToggleDelete(false);
    }
  }, [mutationDelete.isSuccess]);
  return (
    <div className="mt-3 w-100">
      <div className="analystic-table-card">
        <div className="w-100">
          <DataTable
            fixedHeader
            fixedHeaderScrollHeight="300px"
            columns={columns}
            responsive
            data={data}
            pagination
          />
        </div>
      </div>
      <ModalDelete
        size="md"
        isOpen={isToggleDelete}
        toggle={() => {
          setIsToggleDelete(false);
        }}
        title="Delete Speaker"
        body={
          <DeleteForm
            setIsToggleDelete={setIsToggleDelete}
            DeleteParticitant={DeleteParticitant}
            pending={mutationDelete?.isLoading}
          />
        }
      />
      <OffCanvas
        isOffcanvasOpen={isToggleView}
        title="Speaker"
        body={<ViewSpeaker details={speakerDetails} />}
        toggleSaveChanges={() => tog_viewParticipant()}
        directionOffCanvas="end"
        widthOffCanvas={400}
      />
      <OffCanvas
        isOffcanvasOpen={isToggleEdit}
        title="Edit Speaker"
        body={
          <EditSpeaker
            details={speakerDetails}
            setIsOffcanvasOpen={setIsToggleEdit}
          />
        }
        toggleSaveChanges={() => tog_editParticipant()}
        directionOffCanvas="end"
        widthOffCanvas={700}
      />
    </div>
  );
};

export default TableSpeaker;
